import Axios from 'axios';

import {
	GLOBAL_DATA_LOADING,
	GLOBAL_DATA_GET,
	GLOBAL_DATA_ERROR
} from './types';

// Utils
import create_query_params from '../utils/create_query_params';

export const get_global_data = (filters) => dispatch => {
	// console.log(filters)
	dispatch({ type: GLOBAL_DATA_LOADING, payload: true });

	let url = process.env.REACT_APP_SERVER_URL + '/api/global/data?';
	let query = create_query_params(filters);
	url += query;

	Axios.get(url)
	.then((res) => {
		// console.log(res.data)
		dispatch({
			type: GLOBAL_DATA_GET,
			payload: res.data
		});
		dispatch({ type: GLOBAL_DATA_LOADING, payload: false });
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: GLOBAL_DATA_ERROR,
			payload: { type: 'global_data', msg: Object.values(err.response.data)[0] }
		});
		dispatch({ type: GLOBAL_DATA_LOADING, payload: false });
	})
}
